import { queryOptions, useQuery } from "@tanstack/react-query";
import type { ActivePlan } from "./types";

export type UserPlan =
  | {
      status: "logged_out";
      info: null;
    }
  | {
      status: "free_plan_expired";
      info: null;
    }
  | {
      status: "ok";
      info: ActivePlan;
    };

async function getUserPlan(): Promise<UserPlan> {
  return await Promise.resolve({ status: "logged_out", info: null });
}

export const userPlanQueryOptions = queryOptions({
  queryKey: ["user", "plan"],
  queryFn() {
    return getUserPlan();
  },
});

export function useUserPlan() {
  return useQuery(userPlanQueryOptions);
}
